module.exports = __webpack_public_path__ + "assets/img/block-right-a995cef7.png";